import { z } from 'zod';
import { authBundleSchema } from './auth';
import { safeParseApiResponse } from '../parseApiResponse';

export const orderEntitySchema = z
  .object({
    id: z.union([z.string(), z.number()]).optional(),
    numeroCommande: z.union([z.string(), z.number()]).optional(),
    statut: z.string().optional(),
    prixTotal: z.number().optional(),
    paymentStatus: z.string().optional(),
    auth: authBundleSchema.optional(),
  })
  .passthrough();

/** POST /orders, POST /orders/guest */
export const createOrderResponseSchema = z.union([
  z
    .object({
      statusCode: z.union([z.string(), z.number()]).optional(),
      message: z.string().optional(),
      data: orderEntitySchema.optional(),
    })
    .passthrough(),
  orderEntitySchema,
]);

/**
 * Déplie la réponse création commande (gateway NestJS).
 */
export function normalizeCreateOrderResponse(raw) {
  if (!raw || typeof raw !== 'object') {
    return { order: {}, auth: null, raw };
  }

  const order = raw.data ?? raw;
  const auth = order?.auth ?? null;

  return {
    order: order && typeof order === 'object' ? order : {},
    auth,
    raw,
  };
}

export function parseCreateOrderResponse(raw) {
  safeParseApiResponse(createOrderResponseSchema, raw, { label: 'orders/create' });
  return normalizeCreateOrderResponse(raw);
}

/**
 * Déplie l'enveloppe axios + gateway autour d'une commande créée.
 * Équivalent de `response?.data?.data ?? response?.data ?? response ?? {}`.
 */
export function unwrapOrderResponse(response) {
  const raw = response?.data?.data ?? response?.data ?? response ?? {};
  return parseCreateOrderResponse(raw).order;
}
